import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  status$ = new Subject<LoaderStatus|number>();

  start(name = ''): void {
    this.status$.next(name ? ({ name, step: 1 }) : 1);
  }

  stop(name= ''): void {
    this.status$.next(name ? ({ name, step: -1 }) : -1);
  }
}

export interface LoaderStatus {
  name: string;
  step: number;
}
